import { render, staticRenderFns } from "./KwPixel.vue?vue&type=template&id=5b967d15&"
import script from "./KwPixel.vue?vue&type=script&lang=js&"
export * from "./KwPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports